import {
  BodypartType,
  ExerciseTagDto,
  MovementPatternType,
} from "@growth-machine-llc/stridist-api-client";
import { NONE_TAG_ID } from "./TagsFilters";

export const NONE_OPTION = "NONE";
export const ALL_OPTION = "ALL";
export const FILTER_OPTIONS = [ALL_OPTION, NONE_OPTION];

export enum ExerciseCategoryFiltersType {
  BODYPART_TYPE = "BodypartType",
  MOVEMENT_PATTERN_TYPE = "MovementPatternType",
}

export const exerciseCategoryFiltersTypeLabels = {
  [ExerciseCategoryFiltersType.BODYPART_TYPE]: "Bodypart",
  [ExerciseCategoryFiltersType.MOVEMENT_PATTERN_TYPE]: "Movement pattern",
};

export const mapFilters = <T extends BodypartType | MovementPatternType>(
  enumType: Record<string, T>,
  selected?: T[],
): Record<T, boolean> => {
  return Object.values(enumType).reduce<Record<T, boolean>>(
    (acc, type) => {
      acc[type] = selected ? selected.includes(type) : true;
      return acc;
    },
    {} as Record<T, boolean>,
  );
};

export const getAllFilters = <T extends string>(
  filters: Record<T, boolean>,
  checked: boolean,
): Record<T, boolean> => {
  const updated: Record<T, boolean> = {} as Record<T, boolean>;
  Object.keys(filters).forEach((key) => {
    updated[key as T] = key === NONE_OPTION ? false : checked;
  });
  if (!checked) {
    updated[NONE_OPTION as T] = true;
  }
  return updated;
};

export const getFilterStatus = (
  filters: Record<string, boolean>,
): {
  text: string;
  activeCount: number;
} => {
  const total = Object.keys(filters).length;
  const checked = Object.values(filters).filter(Boolean).length;
  const activeCount = checked === 0 || checked === total ? 0 : checked;
  return {
    text: activeCount ? `: ${activeCount}` : "",
    activeCount,
  };
};

export const getTagStatus = (
  tags: ExerciseTagDto[] | undefined,
  selected: number[],
): { text: string; activeCount: number } => {
  if (!tags || tags?.length === 0) return { text: "", activeCount: 0 };
  const total = tags.length + [NONE_TAG_ID].length;
  const checked = selected.length;
  const activeCount = checked === 0 || checked === total ? 0 : checked;
  return {
    text: activeCount ? `: ${activeCount}` : "",
    activeCount,
  };
};
